import {
	ComponentTestPage,
	DateIntervalFieldTest,
	IconsPage,
	DownloadExcel,
	TakePhotoPage,
	MaskTextInputTestPage,
	InvoiceTestPage,
	PDFTest,
	HTMLViewTestPage,
	MobileCarrierBarCode,
	UploadStreamTestPage,
} from "@icoach/development/";
import DashboardPage from "@icoach/dashboard/DashboardPage";
import FRONT_KEY from "@icoach/constants/routerFrontKey";
import CreateOrderPage from "@icoach/accountBook/createOrder/CreateOrderPage";

export const developerRouter = {
	description: "開發用",
	menuName: "開發專用區",
	frontKey: "D999X01",
	children: [
		{
			description: "所有SVG圖檔",
			menuName: "所有Icon",
			strict: true,
			path: "/club/icons/",
			href: "/club/icons/",
			as: IconsPage,
			frontKey: FRONT_KEY.D999X02,
		},
		{
			description: "menu參考",
			menuName: "元件測試",
			strict: true,
			path: "/club/test/components/",
			href: "/club/test/components/",
			as: ComponentTestPage,
			frontKey: FRONT_KEY.D999X03,
		},
		{
			description: "excel",
			menuName: "下載Excel測試",
			strict: true,
			path: "/club/test/excel/",
			href: "/club/test/excel/",
			as: DownloadExcel,
			frontKey: FRONT_KEY.D999X04,
		},
		{
			description: "日期區間元件",
			menuName: "日期區間元件",
			strict: true,
			path: "/club/test/dateIntervalField",
			href: "/club/test/dateIntervalField",
			as: DateIntervalFieldTest,
			frontKey: FRONT_KEY.D999X05,
		},
		{
			description: "拍照且上傳",
			menuName: "拍照上傳",
			strict: true,
			path: "/club/camera",
			href: "/club/camera",
			as: TakePhotoPage,
			frontKey: FRONT_KEY.D999X06,
		},
		{
			description: "PDF下載測試",
			menuName: "PDF下載測試",
			strict: true,
			path: "/club/pdf-download",
			href: "/club/pdf-download",
			as: PDFTest,
			frontKey: FRONT_KEY.D999X07,
		},
		{
			description: "HTMLView測試",
			menuName: "HTMLView測試",
			strict: true,
			path: "/club/html-view",
			href: "/club/html-view",
			as: HTMLViewTestPage,
			frontKey: FRONT_KEY.D999X08,
		},
		{
			description: "特殊輸入框",
			menuName: "特殊輸入框",
			strict: true,
			path: "/club/input-text",
			href: "/club/input-text",
			as: MaskTextInputTestPage,
			frontKey: FRONT_KEY.D999X09,
		},
		{
			description: "發票元件",
			menuName: "發票元件",
			strict: true,
			path: "/club/invoice",
			href: "/club/invoice",
			as: InvoiceTestPage,
			frontKey: FRONT_KEY.D999X10,
		},
		// {
		// 	description: "批次新增會籍",
		// 	menuName: "批次新增會籍",
		// 	strict: true,
		// 	path: "/club/bulk-membershipt/test-data/",
		// 	href: "/club/bulk-membershipt/test-data/",
		// 	as: BulkMambershipDataPage,
		// 	frontKey: FRONT_KEY.D999X11,
		// },
		{
			description: "手機條碼掃描",
			menuName: "手機條碼掃描",
			strict: true,
			path: "/club/mobile-carrier-barcode/",
			href: "/club/mobile-carrier-barcode/",
			as: MobileCarrierBarCode,
			frontKey: FRONT_KEY.D999X11,
		},
		{
			description: "上傳檔案元件測試",
			menuName: "上傳檔案",
			strict: true,
			path: "/club/stream-upload",
			href: "/club/stream-upload",
			as: UploadStreamTestPage,
			frontKey: FRONT_KEY.D999X12,
		},
		{
			description: "新增收入頁面測試",
			menuName: "新增收入頁面",
			strict: true,
			path: "/club/create-order",
			href: "/club/create-order",
			as: CreateOrderPage,
			frontKey: FRONT_KEY.D999X13,
		},
		{
			description: "會員輪廓頁",
			menuName: "會員輪廓頁",
			strict: true,
			path: "/club/dashboard/member/",
			href: "/club/dashboard/member/",
			as: DashboardPage,
			frontKey: FRONT_KEY.D999X14,
		},
	],
};
